module.exports = require("atob");